export default function EncryptCardNum(cardNum) {
    let formatted = "";
    
    if(cardNum) formatted = `${cardNum.substr(0, 4)}-****-****-${cardNum.substr(-4)}`;
    
    return formatted;
}